import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Award, Users } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["pending", "invited", "submitted", "approved", "rejected"];

export default function AdminReferrals() {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/referrals/").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const update = async (id, status, rewarded = null) => {
    try {
      await api.put(`/referrals/${id}`, { status, rewarded });
      toast.success("Aggiornato");
      refresh();
    } catch (e) { toast.error("Errore"); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1 flex items-center gap-2"><Users size={20} /> Referral manager</h1>
      <p className="text-sm text-slate-600 mb-6">Gestisci i manager segnalati al network CXOORA.</p>
      <div className="cxo-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="p-3 text-left">Candidato</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Ruolo target</th>
              <th className="p-3 text-left">Segnalato da</th>
              <th className="p-3 text-left">Stato</th>
              <th className="p-3 text-left">Riconoscimento</th>
              <th className="p-3 text-left">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.map(r => (
              <tr key={r.id} className="border-t border-slate-100">
                <td className="p-3 font-medium">{r.referee_name}</td>
                <td className="p-3 text-slate-600">{r.referee_email}</td>
                <td className="p-3 text-slate-600">{r.referee_role_target || "—"}</td>
                <td className="p-3 text-slate-600">{r.referrer_name}</td>
                <td className="p-3">
                  <Select value={r.status} onValueChange={v => update(r.id, v)}>
                    <SelectTrigger className="h-8 w-32 text-xs"><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
                <td className="p-3">{r.rewarded ? <Badge className="bg-[#FFF6E6] text-[#B7791F] border-0"><Award size={12} className="mr-1" /> Premiato</Badge> : <Button size="sm" variant="outline" onClick={() => update(r.id, r.status, true)}>Premia</Button>}</td>
                <td className="p-3 text-xs text-slate-500">{r.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={7} className="p-10 text-center text-slate-500">Nessun referral</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
